import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API_BASE } from "@/lib/api";

/**
 * After login, OAuth continue page redirects to the backend /api/oauth/authorize
 * which will issue a token and redirect to the connected app.
 */
export default function OAuthContinue() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const app_id = params.get("app_id");
    const state = params.get("state");
    if (!app_id) {
      navigate("/profile");
      return;
    }
    const url = `${API_BASE}/oauth/authorize?app_id=${encodeURIComponent(app_id)}&state=${encodeURIComponent(state || "")}`;
    window.location.replace(url);
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950">
      <div className="flex items-center gap-3 text-zinc-400 text-sm">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span>Redirecting to application…</span>
      </div>
    </div>
  );
}
